import { AppstoreOutlined } from '@ant-design/icons';
import { CgCheckR } from '@react-icons/all-files/cg/CgCheckR';
import { FaCommentDollar } from '@react-icons/all-files/fa/FaCommentDollar';
import { FaTools } from '@react-icons/all-files/fa/FaTools';
import { FaSearch } from '@react-icons/all-files/fa/FaSearch';
import { FaMarker } from '@react-icons/all-files/fa/FaMarker';
import { HiDocumentReport } from '@react-icons/all-files/hi/HiDocumentReport';
import { RiRefundFill } from '@react-icons/all-files/ri/RiRefundFill';
import { RiDatabase2Fill } from '@react-icons/all-files/ri/RiDatabase2Fill';
import { FiActivity } from '@react-icons/all-files/fi/FiActivity';
import { FaUserGraduate } from '@react-icons/all-files/fa/FaUserGraduate';
import { AiOutlineTranslation } from '@react-icons/all-files/ai/AiOutlineTranslation';
import { IoMdContact } from '@react-icons/all-files/io/IoMdContact';
import { Link } from 'react-router-dom';
const ADMINS = [
  'kobi@getzorba.com',
  'mateusz.kwasny@getzorba.com',
  'or@getzorba.com',
  'anj@getzorba.com',
  'john.banas@getzorba.com',
  'stefany.quiroz@getzorba.com',
  'milan.petojevic@getzorba.com',
];
export const getNavItems = ({ userDetails }) => {
  const permissions = userDetails?.permissions || [];
  
  // Helper function to check if user has required permission
  const hasPermission = (requiredPermission) => {
    return permissions.includes(requiredPermission);
  };

  // Helper function to check if user can see item based on permissions
  const canSeeItem = (item) => {
    // Admin, employee, and superuser can see all items
    if (hasPermission('admin') || hasPermission('employee') || hasPermission('superuser')) {
      return true;
    }
    
    // Check specific permissions for each item
    switch (item.key) {
      case '15': // Buyer Agent Report
        return hasPermission('buyer_agent');
      case '13': // Seller Agent Report
        return hasPermission('seller_agent');
      default:
        // For all other items, only admin and employee can see them
        return false;
    }
  };

  let items = [
    {
      key: '1',
      label: <Link to="/">User Search</Link>,
      icon: <AppstoreOutlined />,
    },
    {
      key: '2',
      label: <Link to="/address-checker">Address Lookup Tool</Link>,
      icon: <FaSearch />,
    },
    {
      key: '3',
      label: <Link to="/buybox-checker">Buybox checker</Link>,
      icon: <FaMarker />,
    },
    {
      key: '4',
      label: <Link to="/deal-submission">Deal search</Link>,
      icon: <FaCommentDollar />,
    },
    {
      key: '12',
      label: <Link to="/pre-deal">Pre-Deal search</Link>,
      icon: <AiOutlineTranslation />,
    },    
    {
      key: '5',
      label: <Link to="/partner-approval">Partner approval</Link>,
      icon: <CgCheckR />,
    },
    {
      key: '6',
      label: <Link to="/buyer-activity-report">Institutional Buyers</Link>,
      icon: <HiDocumentReport />,
    },
    {
      key: '13',
      label: <Link to="/agent-contacts-page">Seller Agent Report</Link>,
      icon: <IoMdContact />,
    },
    {
      key: '15',
      label: <Link to="/buyer-agent-report">Buyer Agent Report</Link>,
      icon: <HiDocumentReport />,
    },    
    {
      key: '8',
      label: <Link to="/data-requests">Data requests</Link>,
      icon: <RiDatabase2Fill />,
    },
    {
      key: '9',
      label: (
        <Link to="/institutional-activity-research">Activity research</Link>
      ),
      icon: <FiActivity />,
    },
    {
      key: '11',
      label: <Link to="/state-activity-research">State research</Link>,
      icon: <FiActivity />,
    },
    {
      key: '14',
      label: <Link to="/white-label">WhiteLabel Partners</Link>,
      icon: <CgCheckR />,
    },    
  ];

  // Filter items based on permissions
  items = items.filter(canSeeItem);

  return items;
};
